var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.3335H8.66667C9.4 9.3335 10 8.7335 10 8.00016V1.3335H4C3 1.3335 2.12667 1.88682 1.67334 2.70015",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 11.3335C1.3335 12.4402 2.22683 13.3335 3.3335 13.3335H4.00016C4.00016 12.6002 4.60016 12.0002 5.3335 12.0002C6.06683 12.0002 6.66683 12.6002 6.66683 13.3335H9.3335C9.3335 12.6002 9.9335 12.0002 10.6668 12.0002C11.4002 12.0002 12.0002 12.6002 12.0002 13.3335H12.6668C13.7735 13.3335 14.6668 12.4402 14.6668 11.3335V9.3335H12.6668C12.3002 9.3335 12.0002 9.0335 12.0002 8.66683V6.66683C12.0002 6.30016 12.3002 6.00016 12.6668 6.00016H13.5268L12.3868 4.00684C12.1468 3.5935 11.7068 3.3335 11.2268 3.3335H10.0002V8.00016C10.0002 8.7335 9.40016 9.3335 8.66683 9.3335H8.00016",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 14.6667C11.4032 14.6667 12.0002 14.0697 12.0002 13.3333C12.0002 12.597 11.4032 12 10.6668 12C9.93045 12 9.3335 12.597 9.3335 13.3333C9.3335 14.0697 9.93045 14.6667 10.6668 14.6667Z",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.6667 8Z",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 5.3335H5.3335",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 7.3335H4.00016",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 9.3335H2.66683",
    stroke: "#F38E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckFast);
export default __webpack_public_path__ + "static/media/truckFast.cb70ddbca28e726ef9889eac1b802797.svg";
export { ForwardRef as ReactComponent };